@if (productType) {
  <div class="container single-view" id="edit-product-type">
    <div class="row">
      <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
        <div id="pre-header-wr">
          <a data-testid="back-btn" appBack [fallbackUrl]="'/product-types/' + productTypeId" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'PRODUCT_TYPES.BTN_BACK_TO_PRODUCT_TYPE' | translate }}</a>
        </div>
      </div>
      <div class="col-12">
        <div id="view-header-wr">
          <div class="title-wr">
            <h1 data-testid="edit-producttype-title" class="section-title">{{ 'PRODUCT_TYPE_UPDATE.TITLE' | translate }}</h1>
          </div>
        </div>
        <hr role="presentation" class="w-full mb-3 mt-6 border-t">
        <div class="view-content-wr">
          <div class="row">
            <div class="flex flex-col col-12 mb-2 text-wr">
              <!-- main content -->
              <form class="mt-0" [formGroup]="productTypeForm" data-testid="edit-producttype-form">
                <div class="row">
                  <div class="flex flex-col col-12 mb-4">
                    <h2 data-testid="edit-producttype-details-title"  class="border-b pb-3">{{ 'PRODUCT_TYPE_UPDATE.PRODUCT_TYPE_DETAILS' | translate }}</h2>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-producttype-field-name" class="block text-sm" for="name">{{ 'PRODUCT_TYPE_UPDATE.NAME' | translate }} <i class="icon-required-field"></i></label>
                    <input data-testid="edit-producttype-name-input" type="text" id="name" formControlName="name" autocomplete="off">
                    @if (productTypeForm.get('name')?.invalid && productTypeForm.get('name')?.touched) {
                      <small data-testid="name-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-producttype-field-code" class="block text-sm" for="code">{{ 'PRODUCT_TYPE_UPDATE.CODE' | translate }} <i class="icon-required-field"></i></label>
                    <input data-testid="edit-producttype-code-input" type="text" id="code" formControlName="code" autocomplete="off">
                    @if (productTypeForm.get('code')?.invalid && productTypeForm.get('code')?.touched) {
                      <small data-testid="code-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-producttype-field-image" class="block text-sm" for="imageUrl">{{ 'PRODUCT_TYPE_UPDATE.DEFAULT_URL' | translate }} </label>
                    <input data-testid="edit-producttype-url-input" type="text" formControlName="imageUrl" autocomplete="off">
                  </div>
                  <div class="field-wr col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-producttype-field-hasParent" class="block text-sm mb-3" for="hasParent">{{ 'PRODUCT_TYPE_UPDATE.HAS_PARENT' | translate }}</label>
                    <span class="inline-flex mr-6">
                      <label for="yes" data-testid="edit-producttype-has-parent-yes-label" class="inline-flex items-center cursor-pointer">
                        <p-radioButton data-testid="edit-producttype-has-parent-yes" name="hasParentProductType" value="true" formControlName="hasParentProductType" inputId="yes" />
                        <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                      </label>
                    </span>
                    <span class="inline-flex mr-2">
                      <label for="no" data-testid="edit-producttype-has-parent-no-label" class="inline-flex items-center cursor-pointer">
                        <p-radioButton data-testid="edit-producttype-has-parent-no" name="hasParentProductType" value="false" formControlName="hasParentProductType" inputId="no" />
                        <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                      </label>
                    </span>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3" [ngClass]="{'disabled': productTypeForm.get('hasParentProductType')?.value == 'false'}">
                    <label class="block text-sm" for="parentCollection">{{ 'PRODUCT_TYPE_UPDATE.PARENT_PRODUCT_TYPE' | translate }}</label>
                    <app-custom-dropdown
                      data-testid="parentproducttype"
                      [placeholder]="'PRODUCT_TYPE_UPDATE.SELECT_PARENT_PLACEHOLDER' | translate"
                      optionLabel="text"
                      optionValue="id"
                      [isMultiselect]="false"
                      [showSelectionChips]="true"
                      [showClear]="true"
                      [searchMode]="'remote'"
                      [pageSize]="productTypesRowsPerPageOption"
                      [totalCount]="productTypesTotalRecords"
                      [totalPages]="getTotalPages(productTypesTotalRecords, productTypesRowsPerPageOption)"
                      [options]="productTypesList"
                      formControlName="productType"
                      (onLazyLoad)="onLazyLoadProductTypes($event)">
                    </app-custom-dropdown>
                    @if (productTypeForm.errors?.['requiredproductType'] && isProductTypeRequired()) {
                      <small data-testid="parent-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mt-6 mb-4 pt-8 border-t">
                    <div class="flex items-center justify-end gap-3">
                      <button data-testid="edit-producttype-update-producttype-button" class="btn primary-btn" [disabled]="productTypeForm.invalid" (click)="submitForm()">{{
                      'PRODUCT_TYPE_UPDATE.BTN_UPDATE_PRODUCT_TYPE' | translate }}</button>
                    </div>
                  </div>
                </div>
              </form>
              <!-- /main content -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
